export const headerVariable = {
  Logout: "Logout",
};
